import { render, staticRenderFns } from "./TextFieldType.vue?vue&type=template&id=22f86982&"
import script from "./TextFieldType.vue?vue&type=script&lang=js&"
export * from "./TextFieldType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports